'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/**
 * Module dependencies.
 */

var _virtualElement = require('virtual-element');

var _virtualElement2 = _interopRequireDefault(_virtualElement);

var _enroute = require('enroute');

var _enroute2 = _interopRequireDefault(_enroute);

var _pathToRegexp = require('path-to-regexp');

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

var _normalizePath = require('normalize-path');

var _normalizePath2 = _interopRequireDefault(_normalizePath);

var _sameOrigin = require('same-origin');

var _sameOrigin2 = _interopRequireDefault(_sameOrigin);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _navigate = require('./navigate');

var _navigate2 = _interopRequireDefault(_navigate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Event listeners.
 */

var listeners = {};

/**
 * Debug.
 */

var debug = new _debug2.default('deku-enroute');

/**
 * Exports.
 */

exports.default = { initialState: initialState, render: render, afterMount: afterMount, beforeUnmount: beforeUnmount };

/**
 * Initialize the router.
 */

function initialState(props) {
  var routes = {};
  var location = props.location;

  addRoutes(props.children, null);
  var router = (0, _enroute2.default)(routes);

  debug('routes: %o', routes);
  return { location: location, router: router };

  // add routes with `parent`
  function addRoutes(routes, parent) {
    routes.forEach(function (r) {
      return addRoute(r, parent);
    });
  }

  // add route `el` with `parent`
  function addRoute(el, parent) {
    validate(el);

    var type = el.type;
    var attributes = el.attributes;
    var children = el.children;
    var component = attributes.component;


    if (type.name == 'Redirect') {
      var path = (0, _normalizePath2.default)(join(attributes.from, parent));
      var to = (0, _normalizePath2.default)(join(attributes.to, parent));
      routes[path] = renderRedirect(to);
    } else {
      var _path = (0, _normalizePath2.default)(join(attributes.path, parent));
      var _render = renderRoute(attributes, parent);
      if (children) addRoutes(children, { render: _render, path: _path });
      routes[_path] = _render;
    }
  }
}

/**
 * Render for `<Redirect>`s.
 */

function renderRedirect(to) {
  var toPath = _pathToRegexp2.default.compile(to);
  return function (params) {
    var path = toPath(params);
    (0, _navigate2.default)(path);
    // HACK: deku requires components to return an element
    return (0, _virtualElement2.default)('noscript', null);
  };
}

/**
 * Render for `<Route>`s.
 */

function renderRoute(attrs, parent) {
  return function (params, renderProps) {
    var finalProps = _extends({}, renderProps, attrs, {
      params: params
    });
    var children = (0, _virtualElement2.default)(attrs.component, finalProps);
    return parent ? parent.render(params, { children: children }) : children;
  };
}

/**
 * Render the matching route.
 */

function render(_ref) {
  var state = _ref.state;
  var location = state.location;
  var router = state.router;

  debug('location: %s', location);
  return router(location, { children: null, location: location });
}

/**
 * After mount, add event listeners.
 */

function afterMount(_ref2, _, setState) {
  var id = _ref2.id;

  document.addEventListener('click', onclick);
  window.addEventListener('popstate', onpopstate);
  listeners[id] = { onclick: onclick, onpopstate: onpopstate };

  // handle click
  function onclick(e) {
    // ensure link was clicked
    var el = e.target;
    while (el && el.nodeName != 'A') {
      el = el.parentNode;
    }
    if (!el || el.nodeName != 'A') return;

    if (el.getAttribute('rel') == 'external') return;
    if (!el.getAttribute('href')) return;
    if (el.target) return;
    if (!(0, _sameOrigin2.default)(el.href, window.location)) return;

    e.preventDefault();

    var path = el.pathname;
    window.history.pushState(null, '', path);
    setState({ location: path });
  }

  // handle popstate
  function onpopstate(e) {
    var location = e.state ? e.state.path : window.location.pathname + window.location.hash;
    setState({ location: location });
  }
}

/**
 * Before unmount, remove event listeners.
 */

function beforeUnmount(_ref3) {
  var id = _ref3.id;
  var _listeners$id = listeners[id];
  var onclick = _listeners$id.onclick;
  var onpopstate = _listeners$id.onpopstate;

  document.removeEventListener('click', onclick);
  window.removeEventListener('popstate', onpopstate);
  delete listeners[id];
}

/**
 * Join component `path` with its `parent`.
 */

function join(path, parent) {
  if (path[0] == '/') return path;
  if (parent == null) return path;
  return parent.path + '/' + path;
}

/**
 * Validate the given `component`.
 */

function validate(_ref4) {
  var _ref4$type = _ref4.type;
  var type = _ref4$type === undefined ? {} : _ref4$type;
  var attributes = _ref4.attributes;

  switch (type.name) {
    case 'Route':
      assert(attributes.path, 'path required');
      assert(attributes.component, 'component required');
      break;
    case 'Redirect':
      assert(attributes.from, 'redirect "from" required');
      assert(attributes.to, 'redirect "to" required');
      break;
    default:
      assert(0, 'invalid child provided');
  }
}

/**
 * Assert `expr`.
 */

function assert(expr, msg) {
  if (!expr) throw new Error('deku-enroute: ' + msg);
}
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/deku-enroute/lib/router.js
// module id = 1042
// module chunks = 0